/**
 * MilestoneChip — one tile in the session-live milestone row.
 * Unlocked state drives border + background via the `.ag-milestone--unlocked`
 * modifier; transition duration is tokenised in styles.css.
 */

export interface MilestoneChipOptions {
  readonly title: string;
  readonly unlocked: boolean;
}

export function renderMilestoneChip(opts: MilestoneChipOptions): HTMLElement {
  const chip = document.createElement('div');
  chip.className = opts.unlocked
    ? 'ag-milestone ag-milestone--unlocked'
    : 'ag-milestone';
  chip.textContent = opts.title;
  return chip;
}
